import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
import { ExpandItem } from "./library/expandItem";
import { slugify } from "../../custom_utils/helpers";
class QuestionAnswer extends React.Component {
    render() {
        return ExpandItem({
            innerKey: this.props.question,
            title: this.props.question,
            text: this.props.answer
        });
    }
    constructor(props){
        super(props);
        this.state = {
            opened: false
        };
    }
}
export const FaqBlock = (props)=>{
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "block block--expand",
            children: [
                props.title != "" && /*#__PURE__*/ _jsx("header", {
                    "data-anchor": slugify(props.title),
                    className: "block__header",
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l",
                        children: props.title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "block__content",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "block__list expand__list",
                        children: props.entries.map((answer, question)=>/*#__PURE__*/ _jsx(QuestionAnswer, {
                                question: question,
                                answer: answer
                            }, question)).valueSeq().toArray()
                    })
                })
            ]
        })
    });
};
